import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { style: {"display":"none"} }
const _hoisted_4 = {
  key: 12,
  class: "code-viewer-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_ZUpload = _resolveComponent("ZUpload")!
  const _component_CodeEditor = _resolveComponent("CodeEditor")!
  const _component_json_viewer = _resolveComponent("json-viewer")!
  const _component_el_tree_select = _resolveComponent("el-tree-select")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['form-field-container', _ctx.fields.componentType])
  }, [
    (_ctx.fields.componentType === 'el-input')
      ? (_openBlock(), _createBlock(_component_el_input, {
          key: 0,
          modelValue: _ctx.fields.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fields.value) = $event)),
          placeholder: " ",
          type: _ctx.fields.config.type,
          disabled: _ctx.fields.config.isDisabled,
          clearable: _ctx.fields.config.clearable,
          autocomplete: _ctx.fields.config.autocomplete,
          onInput: _ctx.handleChange
        }, null, 8, ["modelValue", "type", "disabled", "clearable", "autocomplete", "onInput"]))
      : _createCommentVNode("", true),
    (_ctx.fields.componentType === 'el-number')
      ? (_openBlock(), _createBlock(_component_el_input, {
          key: 1,
          modelValue: _ctx.fields.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.fields.value) = $event)),
          placeholder: " ",
          type: _ctx.fields.config.type,
          disabled: _ctx.fields.config.isDisabled,
          clearable: _ctx.fields.config.clearable,
          autocomplete: _ctx.fields.config.autocomplete,
          max: _ctx.fields.config.maxlength,
          min: _ctx.fields.config.minlength,
          onInput: _ctx.handleChange
        }, null, 8, ["modelValue", "type", "disabled", "clearable", "autocomplete", "max", "min", "onInput"]))
      : _createCommentVNode("", true),
    (_ctx.fields.componentType === 'el-textarea')
      ? (_openBlock(), _createBlock(_component_el_input, {
          key: 2,
          modelValue: _ctx.fields.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.fields.value) = $event)),
          placeholder: " ",
          type: "textarea",
          disabled: _ctx.fields.config.isDisabled,
          clearable: _ctx.fields.config.clearable,
          class: _normalizeClass(_ctx.fields.config.className),
          onInput: _ctx.handleChange
        }, null, 8, ["modelValue", "disabled", "clearable", "class", "onInput"]))
      : _createCommentVNode("", true),
    (_ctx.fields.componentType === 'el-select')
      ? (_openBlock(), _createBlock(_component_el_select, {
          key: 3,
          filterable: true,
          modelValue: _ctx.fields.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.fields.value) = $event)),
          class: "filter-item",
          placeholder: "输入关键字搜索",
          disabled: _ctx.fields.config.isDisabled,
          clearable: _ctx.fields.config.clearable,
          multiple: _ctx.fields.config.multiple,
          remote: _ctx.fields.config.remote,
          "collapse-tags": _ctx.fields.config.collapseTags,
          focus: _ctx.handleFocus(_ctx.fields),
          "remote-method": query => _ctx.remoteMethod(query, _ctx.fields),
          style: _normalizeStyle({ width: _ctx.fields.config.width || '100%' }),
          onChange: _ctx.handleChange
        }, {
          default: _withCtx(() => [
            (_ctx.fields.option && _ctx.fields.option.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.fields.option, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.id,
                    label: item[_ctx.fields.config.alias] || item.name,
                    value: item.id,
                    disabled: item.disable
                  }, {
                    default: _withCtx(() => [
                      (item.disable)
                        ? (_openBlock(), _createBlock(_component_el_tooltip, {
                            key: 0,
                            class: "box-item",
                            effect: "dark",
                            content: item.disableContent || '改选项不可选' ,
                            placement: "left",
                            "show-after": 200
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(item[_ctx.fields.config.alias] || item.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["content"]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(item[_ctx.fields.config.alias] || item.name), 1))
                    ]),
                    _: 2
                  }, 1032, ["label", "value", "disabled"]))
                }), 128))
              : (_openBlock(), _createBlock(_component_el_option, {
                  key: 1,
                  value: -1,
                  disabled: ""
                }, {
                  default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                    _createTextVNode(" 暂无数据 ", -1)
                  ]))]),
                  _: 1
                }))
          ]),
          _: 1
        }, 8, ["modelValue", "disabled", "clearable", "multiple", "remote", "collapse-tags", "focus", "remote-method", "style", "onChange"]))
      : _createCommentVNode("", true),
    (_ctx.fields.componentType === 'el-select-obejct')
      ? (_openBlock(), _createBlock(_component_el_select, {
          key: 4,
          filterable: true,
          modelValue: _ctx.fields.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.fields.value) = $event)),
          class: "filter-item",
          placeholder: "输入关键字搜索",
          disabled: _ctx.fields.config.isDisabled,
          clearable: _ctx.fields.config.clearable,
          multiple: _ctx.fields.config.multiple,
          remote: _ctx.fields.config.remote,
          "collapse-tags": _ctx.fields.config.collapseTags,
          "value-key": _ctx.fields.config.alias,
          focus: _ctx.handleFocus(_ctx.fields),
          "remote-method": query => _ctx.remoteMethod(query, _ctx.fields),
          style: _normalizeStyle({ width: _ctx.fields.config.width || '100%' }),
          onChange: _ctx.handleChange
        }, {
          default: _withCtx(() => [
            (_ctx.fields.option && _ctx.fields.option.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.fields.option, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.id,
                    label: item[_ctx.fields.config.alias] || item.name,
                    value: item,
                    disabled: item.disable
                  }, {
                    default: _withCtx(() => [
                      (item.disable)
                        ? (_openBlock(), _createBlock(_component_el_tooltip, {
                            key: 0,
                            class: "box-item",
                            effect: "dark",
                            content: item.disableContent || '改选项不可选' ,
                            placement: "left",
                            "show-after": 200
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(item[_ctx.fields.config.alias]), 1)
                            ]),
                            _: 2
                          }, 1032, ["content"]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(item[_ctx.fields.config.alias]), 1))
                    ]),
                    _: 2
                  }, 1032, ["label", "value", "disabled"]))
                }), 128))
              : (_openBlock(), _createBlock(_component_el_option, {
                  key: 1,
                  value: -1,
                  disabled: ""
                }, {
                  default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                    _createTextVNode(" 暂无数据 ", -1)
                  ]))]),
                  _: 1
                }))
          ]),
          _: 1
        }, 8, ["modelValue", "disabled", "clearable", "multiple", "remote", "collapse-tags", "value-key", "focus", "remote-method", "style", "onChange"]))
      : _createCommentVNode("", true),
    (_ctx.fields.componentType === 'el-cascader')
      ? (_openBlock(), _createBlock(_component_el_cascader, {
          key: 5,
          filterable: true,
          modelValue: _ctx.fields.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.fields.value) = $event)),
          placeholder: "输入关键字搜索",
          options: _ctx.fields.option,
          props: _ctx.fields.config.props,
          disabled: _ctx.fields.config.isDisabled,
          clearable: _ctx.fields.config.clearable,
          "collapse-tags": _ctx.fields.config.collapseTags,
          onFocus: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleFocus(_ctx.fields))),
          onChange: _ctx.handleChange
        }, {
          default: _withCtx(({ data }) => [
            _createElementVNode("span", null, _toDisplayString(data.name), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "options", "props", "disabled", "clearable", "collapse-tags", "onChange"]))
      : _createCommentVNode("", true),
    (_ctx.fields.componentType === 'el-cascader-provinces')
      ? (_openBlock(), _createBlock(_component_el_cascader, {
          key: 6,
          filterable: true,
          placeholder: "输入关键字搜索",
          modelValue: _ctx.fields.value,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.fields.value) = $event)),
          props: _ctx.provincesLoad,
          disabled: _ctx.fields.config.isDisabled,
          clearable: _ctx.fields.config.clearable,
          onChange: _ctx.handleChange
        }, {
          default: _withCtx(({ node, data }) => [
            _createElementVNode("span", _hoisted_3, _toDisplayString(node.isLeaf), 1),
            _createElementVNode("span", null, _toDisplayString(data.name), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "props", "disabled", "clearable", "onChange"]))
      : _createCommentVNode("", true),
    (_ctx.fields.componentType === 'el-date-picker')
      ? (_openBlock(), _createBlock(_component_el_date_picker, {
          key: 7,
          modelValue: _ctx.fields.value,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.fields.value) = $event)),
          placeholder: " ",
          disabled: _ctx.fields.config.isDisabled,
          clearable: _ctx.fields.config.clearable,
          type: _ctx.fields.config.type,
          format: _ctx.fields.config.format,
          "value-format": _ctx.fields.config.valueFormat,
          onChange: _ctx.handleChange
        }, null, 8, ["modelValue", "disabled", "clearable", "type", "format", "value-format", "onChange"]))
      : _createCommentVNode("", true),
    (_ctx.fields.componentType === 'el-tag')
      ? (_openBlock(), _createBlock(_component_el_select, {
          key: 8,
          filterable: true,
          modelValue: _ctx.fields.value,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.fields.value) = $event)),
          class: "filter-item",
          placeholder: "输入关键字搜索",
          disabled: _ctx.fields.config.isDisabled,
          clearable: _ctx.fields.config.clearable,
          multiple: "",
          "allow-create": "",
          remote: "",
          "collapse-tags": _ctx.fields.config.collapseTags,
          focus: _ctx.handleFocus(_ctx.fields),
          "remote-method": query => _ctx.remoteTagMethod(query, _ctx.fields),
          onChange: _ctx.handleChange
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields.option, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item,
                label: item,
                value: item
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "disabled", "clearable", "collapse-tags", "focus", "remote-method", "onChange"]))
      : _createCommentVNode("", true),
    (_ctx.fields.componentType === 'el-autocomplete')
      ? (_openBlock(), _createBlock(_component_el_autocomplete, {
          key: 9,
          modelValue: _ctx.fields.value,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.fields.value) = $event)),
          placeholder: "输入关键字搜索",
          disabled: _ctx.fields.config.isDisabled,
          clearable: _ctx.fields.config.clearable,
          "fetch-suggestions": (query, cb) => _ctx.remoteFetchSuggestions(query, _ctx.fields, cb),
          onInput: _ctx.handleChange
        }, null, 8, ["modelValue", "disabled", "clearable", "fetch-suggestions", "onInput"]))
      : _createCommentVNode("", true),
    (_ctx.fields.componentType === 'el-contacts-group')
      ? (_openBlock(), _createBlock(_component_el_select, {
          key: 10,
          filterable: true,
          modelValue: _ctx.fields.value,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.fields.value) = $event)),
          class: "filter-item",
          placeholder: "输入关键字搜索",
          disabled: _ctx.fields.config.isDisabled,
          clearable: _ctx.fields.config.clearable,
          multiple: _ctx.fields.config.multiple,
          remote: _ctx.fields.config.remote,
          "collapse-tags": _ctx.fields.config.collapseTags,
          focus: _ctx.groupRemoteMethod('', _ctx.fields),
          "remote-method": query => _ctx.groupRemoteMethod(query, _ctx.fields),
          onChange: _ctx.handleChange,
          style: _normalizeStyle({ width: _ctx.fields.config.width || 'auto' })
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields.option, (group) => {
              return (_openBlock(), _createBlock(_component_el_option_group, {
                key: group.companyId,
                label: group.companyName
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.contacts, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.name,
                      value: item.id,
                      disabled: item.disable
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["label", "value", "disabled"]))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["label"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "disabled", "clearable", "multiple", "remote", "collapse-tags", "focus", "remote-method", "onChange", "style"]))
      : _createCommentVNode("", true),
    (_ctx.fields.componentType === 'el-upload')
      ? (_openBlock(), _createBlock(_component_ZUpload, {
          key: 11,
          option: _ctx.fields,
          onChanged: _cache[12] || (_cache[12] = ($event: any) => (_ctx.handleUploadChange($event, _ctx.fields))),
          value: _ctx.fields.value
        }, null, 8, ["option", "value"]))
      : _createCommentVNode("", true),
    (_ctx.fields.componentType === 'el-json')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_CodeEditor, {
            modelValue: _ctx.fields.value,
            "onUpdate:modelValue": [
              _cache[13] || (_cache[13] = ($event: any) => ((_ctx.fields.value) = $event)),
              _cache[14] || (_cache[14] = ($event: any) => (_ctx.handleCodeEditorChange($event, _ctx.fields)))
            ],
            defaultValue: _ctx.fields.value
          }, null, 8, ["modelValue", "defaultValue"]),
          _createVNode(_component_json_viewer, {
            value: _ctx.fields.config.codevalue,
            "expand-depth": 5,
            copyable: ""
          }, null, 8, ["value"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.fields.componentType === 'el-tree')
      ? (_openBlock(), _createBlock(_component_el_tree_select, {
          key: 13,
          filterable: true,
          data: _ctx.fields.option,
          "render-after-expand": false,
          modelValue: _ctx.fields.value,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.fields.value) = $event)),
          placeholder: "输入关键字搜索",
          "check-strictly": "",
          "node-key": _ctx.fields.config.nodeKey || 'id',
          props: _ctx.fields.config.treeProps || { children: 'children', label: 'name' },
          disabled: _ctx.fields.config.isDisabled,
          clearable: _ctx.fields.config.clearable,
          onChange: _ctx.handleChange
        }, null, 8, ["data", "modelValue", "node-key", "props", "disabled", "clearable", "onChange"]))
      : _createCommentVNode("", true)
  ], 2))
}